// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".data-fetch-error {\n  width: 500px;\n  margin: 5em auto;\n  padding: 1em;\n  background: #eee;\n  border-radius: 5px;\n}\n.data-fetch-error h2 {\n  color: #A01414;\n  margin-block-start: 0.5em;\n  margin-block-end: 0.5em;\n}\n.data-fetch-error h3 {\n  margin-block-start: 1em;\n  margin-block-end: 0.5em;\n}\n", ""]);
// Exports
module.exports = exports;
